export function generateUuid() {
  try {
    const chars = '0123456789abcdef'.split('');
    const uuid = [];
    for (let i = 0; i < 16; i++) {
      uuid.push(chars[Math.floor(Math.random() * chars.length)]);
    }
    return uuid.join('');
  } catch (e) {
    return null;
  }
}
export function readCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export function getUtk() {
  try {
    const hstcCookie = readCookie('__hstc') || '';
    const utk = hstcCookie.split('.')[1];
    return utk;
  } catch (e) {
    return null;
  }
}
export function getLocalStorageItem(key) {
  try {
    return localStorage.getItem(key);
  } catch (err) {
    return null;
  }
}
export function getBooleanFromString(string) {
  return string === 'true';
}
export function getQueryParam(string) {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(string);
  } catch (err) {
    return null;
  }
}
export function getStashedUuid() {
  try {
    return getQueryParam('luid') || readCookie('luid') || null;
  } catch (e) {
    return null;
  }
}